<template>
  <div>
    <b-container fluid class="p-0">
      <main>
        <CommonTitle class="sp-h1-font-size fs-24-bold" :titleProps="title"/>
        <!-- コンテンツ領域 -->
        <b-card class="p-0 m-0">
            <p class="p-0 m-0 mb-3 fs-14-regular" v-html="explanation"></p>
          <b-row>
            <b-col md="6" sm="12"><p class="fs-12-bold mb-1">TAS ID</p>
              <validation-provider class="fs-14-regular" name="TAS ID">
                <b-form-group>
                  <b-form-input
                          class="text-dark"
                          type="text"
                          v-model="tasId"
                          :readonly="true"
                  />
                </b-form-group>
              </validation-provider>
            </b-col>
            <b-col md="6" sm="12" class="padding-col"><p class="fs-12-bold mb-1">会社名</p>
              <validation-provider class="fs-14-regular" name="会社名">
                <b-form-group>
                  <b-form-input
                          class="text-dark"
                          type="text"
                          v-model="companyName"
                          :readonly="true"
                  />
                </b-form-group>
              </validation-provider>
            </b-col>
          </b-row>
              <validation-observer ref="inquiryValidationObserver" v-slot="{ handleSubmit }">
                <b-form @submit.stop.prevent="handleSubmit(onSubmit)" @keydown.enter.prevent>
                  <b-row>
                  <b-col md="6" sm="12"><p class="fs-12-bold mb-1">依頼者名</p>
                  <validation-provider class="fs-14-regular" name="依頼者名" :rules="{ max:100 }" v-slot="validationContext">
                    <b-form-group>
                      <b-form-input
                        :class="!isConfirm ? '' : 'text-dark'"
                        :style="{ backgroundColor: isConfirm ? '#fff' : '' }"
                        type="text"
                        v-model="name"
                        :readonly="isConfirm"
                        :state="isConfirm ? null : getValidationState(validationContext)"
                        placeholder="依頼される方のお名前をご記入ください。"
                        aria-describedby="input-pw-live-feedback"
                      />
                      <b-form-invalid-feedback id="input-pw-live-feedback">{{ validationContext.errors[0] }}</b-form-invalid-feedback>
                    </b-form-group>
                  </validation-provider>
                  </b-col>
                  </b-row>
                  <validation-provider class="mb-3" name="お問い合わせ内容" :rules="{ required: true, max:1000 }" v-slot="validationContext" v-bind:class= "{'form-required': !isConfirm }">
                    <b-form-group  class="fs-12-bold" >
                      <label>お問い合わせ内容 <span class="validate ml-1">※必須</span></label>
                      <b-form-textarea
                        :class="!isConfirm ? '' : 'text-dark'"
                        :style="{ backgroundColor: isConfirm ? '#fff' : '' }"
                        v-model="contents"
                        rows="5"
                        max-rows="6"
                        :readonly="isConfirm"
                        placeholder="お問い合わせ内容をご記入ください。"
                        :state="isConfirm ? null : getValidationState(validationContext)"
                        aria-describedby="input-pw-live-feedback"
                      />
                      <b-form-invalid-feedback id="input-pw-live-feedback">{{ validationContext.errors[0] }}</b-form-invalid-feedback>
                    </b-form-group>
                  </validation-provider>
                  <div class="text-center mt-5 pt-5 mb-5 pb-5" v-show="isConfirm">
                    <b-button variant="outline-secondary" pill class="mr-5 fs-14-bold btn-under-2-char" style="max-width: 200px;" @click="backStep">戻る</b-button>
                    <b-button variant="primary" pill class="ml-5 fs-14-bold btn-under-2-char" style="max-width: 200px;" type="submit">送信</b-button>
                  </div>
                  <!-- ローディング -->
                  <b-modal centered :title="loadingText" v-model="modalShow" hide-header hide-footer hide-header-close no-close-on-backdrop no-close-on-esc>
                    <CommonLoader :title="loadingText"/>
                  </b-modal>
                </b-form>
                  <div class="text-center my-3" v-show="!isConfirm">
                    <b-button variant="primary" pill class="fs-14-bold btn-under-2-char" style="max-width: 200px;" @click="nextStep">次へ</b-button>
                  </div>
              </validation-observer>
          <div v-show="!isConfirm">
            <hr>
            <p class="mb-3 fs-18-bold">お電話でのご連絡</p>
            <p class="mb-1 fs-14-regular">以下の電話番号にご連絡ください。</p>
            <p class="mb-1 fs-14-bold text-primary"><u>03-5958-9331</u></p>
            <p class="fs-12-regular mb-0">営業時間：9:00～21:00 ※夏季・冬季・GW特別期間を除く年中無休。<br>
              お問い合わせ時はお客様ID（TASID）をお伝えください。<br>
              24時間コースをご契約中のお客様は「転送先番号のご案内」に記載されている番号へご連絡をお願いいたします。</p>
          </div>
        </b-card>
      </main>
      <common-validate-check-alert
        @isValidAlertClose="alertClose"
        :isValidAlertProps="isValidAlert"
        :isValidAlertMessageProps="isValidAlertMessage"
      />
    </b-container>
  </div>
</template>

<script>
// Vuex
import { mapActions } from 'vuex'
// NOTE: ローディングの共通文言を取得
import LoadingTxt from '../../../utils/loading-text-util'
import { SET_USER_INFO } from '../../../modules/common/mutation-types'
// NOTE: トーストの共通文言を取得
import ToastTextUtil from '../../../utils/toast-text-util'
// NOTE: 共通タイトルUI
import CommonTitle from '../../../components/common/CommonTitle'
// NOTE: エラー処理util
import ErrorHandleUtil from '@/utils/error-handle-util'
// NOTE: バリデートアラート表示コンポーネント
import CommonValidateCheckAlert from '../../../components/common/CommonValidateCheckAlert'

import CommonLoader from '@/components/common/CommonLoader.vue'

export default {
  name: 'changeLoginId',
  components: {
    CommonLoader,
    CommonTitle,
    CommonValidateCheckAlert
  },
  data () {
    return {
      isValidAlertMessage: [],
      isValidAlert: false,
      name: '',
      contents: '',
      loadingText: '',
      companyName: '',
      tasId: '',
      modalShow: false,
      isConfirm: false,
      errors: {},
      title: 'お問い合わせ',
      explanation: '以下の項目に必要事項をご記入後、「次へ」ボタンを押してください。'
    }
  },
  mounted () {
    this.isSpUserAgent = navigator.userAgent.match(/iPhone|Android.+Mobile/)
    this.customer_id = sessionStorage.getItem('customer_id')
    this.getUserInfo()
  },
  methods: {
    // map Vuex actions
    ...mapActions('common', [SET_USER_INFO]),

    alertClose () {
      this.isValidAlert = false
    },
    getValidationState ({ dirty, validated, valid = null }) {
      return dirty || validated ? valid : null
    },
    backStep () {
      this.isConfirm = false
      this.isValidAlert = false
      this.title = 'お問い合わせ'
      this.explanation = '以下の項目に必要事項をご記入後、「次へ」ボタンを押してください。'
    },
    nextStep () {
      this.$refs.inquiryValidationObserver.validate().then(valid => {
        if (valid) {
          this.isConfirm = true
          this.title = '内容確認'
          this.explanation = '以下の内容でよろしければ、「送信」ボタンをクリックしてください。<br>※内容を修正する場合は、「戻る」ボタンをクリックし、該当画面まで戻って修正してください。'
        } else {
          this.isValidAlertMessage = []
          const validAlertObj = {}
          validAlertObj['itemName'] = 'お問い合わせフォーム'
          validAlertObj['itemList'] = []
          const validItem = this.$refs.inquiryValidationObserver.errors
          Object.keys(validItem).forEach(key => {
            if (validItem[key].length !== 0) {
              validAlertObj['itemList'].push(validItem[key][0])
            }
          })
          this.isValidAlertMessage.push(validAlertObj)
          this.isValidAlert = true
        }
      })
    },
    // NOTE: 会社名取得
    getUserInfo () {
      this.SET_USER_INFO({
        customer_id: sessionStorage.getItem('customer_id')

      }).then(res => {
        this.companyName = res.data.corporate_name
        this.tasId = res.data.tas_id

        if (res.data.result_code === 403) {
          // セッション切れたのでログイン画面に飛ぶ
          if (this.$route.path !== '/mypage/login') this.$router.push({ path: '/mypage/login' })
        }
      }).catch(err => {
        console.log(err)
        if (ErrorHandleUtil.authErrorHandle(err, this.$route.path, this.$router)) return
        this.$bvToast.toast(
          err.message,
          {
            title: ToastTextUtil.errorTitle,
            variant: 'danger',
            noAutoHide: true,
            toaster: 'b-toaster-top-center'
          }
        )
      })
    },

    onSubmit () {
      this.loadingText = LoadingTxt.getTxt
      this.modalShow = true
      let url = `${process.env.VUE_APP_BASE_API_URL}/api/v1/mypage/inquiry`

      this.$axios.request({
        method: 'post',
        url: url,
        data: {
          tas_id: sessionStorage.getItem('tas_id'),
          name: this.name,
          content: this.contents,
          mypage_login_id: sessionStorage.getItem('account_id')
        },
        withCredentials: true
      }).then(res => {
        this.$bvToast.toast(
          '正常に処理が完了しました。',
          {
            title: ToastTextUtil.successTitle,
            variant: 'success',
            toaster: 'b-toaster-top-center'
          }
        )
        this.$router.push({ path: '/mypage/inquiry/complete' })
      }).catch(error => {
        this.$bvToast.toast(
          error.message,
          {
            title: ToastTextUtil.errorTitle,
            variant: 'danger',
            noAutoHide: true,
            toaster: 'b-toaster-top-center'
          }
        )
      }).finally(() => {
        this.modalShow = false
      })
    }
  }
}
</script>
<style lang="scss">
.form-flex {
  display: flex;
  align-items: center;
  margin-bottom: 1rem;

  fieldset {
    display: contents;
  }

  .col-form-label {
    white-space: nowrap;
    width: auto;
    margin-right: 8px;

    & + div {
      width: 100%;

      input {
        max-width: 400px;
      }
    }
  }
}

.form-required {
  legend {
    &::after {
      content: "※必須";
      display: inline-block;
      color: #D64D62;
      font-size: 0.75rem;
      height: 20px;
      line-height: 20px;
      padding: 0 4px;
      border-radius: 1px;
      margin-left: 4px;
    }
  }
}

.padding-col {
  padding-left: 0.25rem;
}
@media screen and (max-width: 767px) {
  .padding-col {
    padding-left: 0.75rem;
  }
}
</style>
